import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const AwardsForm = ({
  initialValues = {},
  onSubmit,
  editMode,
  categories = [],
}) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (initialValues && Object.keys(initialValues).length > 0) {
      form.setFieldsValue({
        category_id: initialValues.category_id || undefined,
        title_id: initialValues.title_id || "",
        title_en: initialValues.title_en || "",
      });

      if (initialValues.image) {
        if (Array.isArray(initialValues.image)) {
          setFileList(initialValues.image);
        } else if (typeof initialValues.image === "string") {
          setFileList([
            {
              uid: "-1",
              name: "image.jpg",
              status: "done",
              url: `${BASE_URL}${initialValues.image}`,
            },
          ]);
        } else {
          setFileList([]);
        }
      } else {
        setFileList([]);
      }
    } else {
      form.resetFields();
      setFileList([]);
    }
  }, [initialValues, form, BASE_URL]);

  const handleFinish = async (values) => {
    const formData = new FormData();

    formData.append("category_id", values.category_id);
    formData.append("title_id", values.title_id);
    formData.append("title_en", values.title_en);

    if (fileList.length > 0 && fileList[0]?.originFileObj) {
      formData.append("image", fileList[0].originFileObj);
    }

    await onSubmit(formData);
    form.resetFields();
    setFileList([]);
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item
        label="Category"
        name="category_id"
        rules={[{ required: true, message: "Category harus diisi" }]}
      >
        <Select
          placeholder="Select category"
          options={categories.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
        />
      </Form.Item>

      <Form.Item
        label="Title ID"
        name="title_id"
        rules={[{ required: true, message: "Title ID harus diisi" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        label="Title EN"
        name="title_en"
        rules={[{ required: true, message: "Title EN harus diisi" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Image" name="image">
        <Upload
          beforeUpload={() => false}
          fileList={fileList}
          onChange={({ fileList: newFileList }) => setFileList(newFileList)}
          maxCount={1}
          listType="picture"
        >
          <Button icon={<UploadOutlined />}>Upload Gambar</Button>
        </Upload>
      </Form.Item>

      <Form.Item style={{ textAlign: "right" }}>
        <Button
          htmlType="submit"
          style={{
            backgroundColor: "#ec4899",
            borderColor: "#ec4899",
            color: "#fff",
          }}
        >
          {editMode ? "Update" : "Add"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AwardsForm;
